import localeOrder from '@/views/order/list/locale/en-US';
import localeMessageBox from '@/components/message-box/locale/en-US';
import localeLogin from '@/views/login/locale/en-US';

import localeWorkplace from '@/views/dashboard/workplace/locale/en-US';
/** simple */
import localeMonitor from '@/views/dashboard/monitor/locale/en-US';

import localeSearchTable from '@/views/list/search-table/locale/en-US';
import localeGiftSearchTable from '@/views/gift/list/locale/en-US';
import localeCardList from '@/views/list/card/locale/en-US';

import localeStepForm from '@/views/form/step/locale/en-US';
import localeGroupForm from '@/views/form/group/locale/en-US';

import localeBasicProfile from '@/views/profile/basic/locale/en-US';

import localeDataAnalysis from '@/views/visualization/data-analysis/locale/en-US';
import localeMultiDAnalysis from '@/views/visualization/multi-dimension-data-analysis/locale/en-US';

import localeSuccess from '@/views/result/success/locale/en-US';
import localeError from '@/views/result/error/locale/en-US';

import locale403 from '@/views/exception/403/locale/en-US';
import locale404 from '@/views/exception/404/locale/en-US';
import locale500 from '@/views/exception/500/locale/en-US';

import localeUserInfo from '@/views/user/info/locale/en-US';
import localeUserSetting from '@/views/user/setting/locale/en-US';
/** simple end */
import localeBiggieCard from '@/views/users/setting/locale/zh-CN';
import localeReward from '@/views/reward/list/locale/en-US';
import localeBiggie from '@/views/biggie/list/locale/en-US';
import localeUsers from '@/views/users/list/locale/en-US';
import localeRechargeLog from '@/views/recharge-log/list/locale/en-US';

import localeSettings from './en-US/settings';

export default {
  'menu.dashboard': 'Dashboard',
  'menu.list': 'List',
  'menu.gift': 'Gift',
  'menu.result': 'Result',
  'menu.exception': 'Exception',
  'menu.form': 'Form',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.recharge': 'Recharge Diamonds',
  'menu.visualization': 'Data Visualization',
  'menu.user': 'User Center',
  'navbar.docs': 'Docs',
  'navbar.action.locale': 'Switch to English',
  'recharge.title': 'Recharge Diamonds',
  'recharge.amount': 'Amount',
  'recharge.amountPlaceholder': 'Please enter the amount of diamonds',
  'recharge.amountTip': 'Minimum recharge is 1000 diamonds',
  'recharge.amountError': 'Amount cannot be less than 1000 diamonds',
  'recharge.paymentMethod': 'Payment Method',
  'recharge.paypalDesc': 'Credit Card, Debit Card & PayPal Account',
  'recharge.diamondAmount': 'Diamond Amount',
  'recharge.usdAmount': 'USD Amount',
  'recharge.handlingFee': 'Handling Fee',
  'recharge.totalAmount': 'Total',
  'recharge.submit': 'Recharge Now',
  'recharge.reset': 'Reset',
  'recharge.redirecting': 'Redirecting to payment page...',
  'recharge.failed': 'Failed to create recharge order',
  ...localeSettings,
  ...localeMessageBox,
  ...localeLogin,
  ...localeWorkplace,
  /** simple */
  ...localeMonitor,
  ...localeSearchTable,
  ...localeGiftSearchTable,
  ...localeCardList,
  ...localeStepForm,
  ...localeGroupForm,
  ...localeBasicProfile,
  ...localeDataAnalysis,
  ...localeMultiDAnalysis,
  ...localeSuccess,
  ...localeError,
  ...locale403,
  ...locale404,
  ...locale500,
  ...localeUserInfo,
  ...localeUserSetting,

  ...localeOrder,
  ...localeBiggieCard,
  ...localeReward,
  ...localeBiggie,
  ...localeUsers,
  ...localeRechargeLog,
  /** simple end */
};
